import React from 'react';
import { BookOpenIcon, FingerprintIcon, GiftIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 comprehensive volumes'
}, {
  icon: GiftIcon,
  label: '5 exclusive bonuses'
}, {
  icon: FingerprintIcon,
  label: '+450 ready-to-use resources'
}, {
  icon: UsersIcon,
  label: 'Teachers, students and educators'
}];
export function SocialProof() {
  return <section className="metal py-5" aria-label="What the teacher ready includes" data-id="element-221" data-mp="3ebm5a6drpy1">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-navy-950 sm:justify-between" data-id="element-222" data-mp="8dy7y809yeig">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-223" data-mp="3ut0vavwx97qt">
            <Icon className="h-5 w-5 text-navy-700" aria-hidden="true" data-id="element-224" data-mp="3ur6adhlnhfmq" /> {label}
          </span>)}
      </div>
    </section>;
}